import React from 'react';
import './ellipsis.scss';

function EllipsisLoader() {
  return (
    <div className="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default EllipsisLoader;
